import { render, staticRenderFns } from "./PSocialModal.vue?vue&type=template&id=6b2ebf28&scoped=true&"
import script from "./PSocialModal.vue?vue&type=script&lang=js&"
export * from "./PSocialModal.vue?vue&type=script&lang=js&"
import style0 from "./PSocialModal.vue?vue&type=style&index=0&id=6b2ebf28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ebf28",
  null
  
)

export default component.exports